import ReportPostsLayout from "layouts/ReportPostsLayout";

const SexualReports = () => {
    return (
        <ReportPostsLayout
            breadCrumbTitle="Unwanted Sexual Content"
            title="Unwanted Sexual Content Posts Reports"
        >
            <span>No Posts</span>
        </ReportPostsLayout>
    );
};

export default SexualReports;
